const IDENTITY_PROVIDERS = {
  APPLE: "apple",
  FACEBOOK: "facebook",
  GOOGLE: "google-new",
};

Object.freeze(IDENTITY_PROVIDERS);

export { IDENTITY_PROVIDERS };
